import { UserAbilities, UserPermissions } from "@models/ISchema";
import { Requirements } from "../settings";

/**
 * Returns true is all the given `requiredAbilities` exists and are true in the
 * given `userAbilities`.
 *
 * @param requirements Requirements
 * @param userAbilities UserAbilities
 * @param userPermissions ("read" | "update" | "create" | "delete")[]
 *
 * @return boolean
 */
const moduleIsAccessible = (
  requirements: Requirements,
  userAbilities: UserAbilities,
  userPermissions: UserPermissions,
): boolean => {
  const requiredAbilities = requirements?.abilities;
  const requiredPermissions = requirements?.permissions;

  if (requiredAbilities.length === 0 && requiredPermissions.length === 0) {
    return true;
  }

  const validAbilities = requiredAbilities.every(ability => userAbilities?.[ability] === true);
  const validPermissions = requiredPermissions.every(
    permission => userPermissions?.[permission] === true,
  );

  return validAbilities && validPermissions;
};

export default moduleIsAccessible;
